import React from 'react';
import Placeholder from 'components/consumer/Placeholder';

const ColorFiltersPlaceholder = () => (
  <div className="items-center flex justify-between w-full mb-4">
    <Placeholder
      type="rect"
      loading
      style={{ width: '100px', height: '24px' }}
    />
    <div className="hidden md:block">
      <ul className="flex flex-wrap w-full overflow-auto py-2 px-1 m-0 list-none max-[767px]:hidden">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(index => (
          <Placeholder
            key={index}
            type="round"
            loading
            style={{ width: '20px', height: '20px' }}
            className="mr-1"
          />
        ))}
      </ul>
    </div>
  </div>
);

const MobileColorFiltersPlaceholder = () => (
  <ul className="flex w-full overflow-visible list-none md:hidden m-2 ml-0">
    {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(index => (
      <Placeholder
        key={index}
        type="round"
        loading
        style={{ minWidth: '40px', minHeight: '40px' }}
        className="mr-1"
      />
    ))}
  </ul>
);

const PDPUpholsteryFiltersPlaceholder = () => (
  <ul className="flex w-full overflow-visible pb-6 px-1 m-0 list-none md:mb-7">
    {[0, 1, 2, 3, 4, 5].map(index => (
      <Placeholder
        key={index}
        type="rect"
        loading
        style={{ minWidth: '65px', minHeight: '35px' }}
        className="mb-1.5 mr-2.5 round"
      />
    ))}
  </ul>
);

const PDPUpholsterySortByPlaceholder = () => (
  <Placeholder
    type="rect"
    loading
    style={{ minHeight: '38px' }}
    className="hidden md:block my-3"
  />
);

const ActiveFabricAndSwatchButtonPlaceholder = () => (
  <div className="flex flex-row justify-between mb-2">
    <div className="flex flex-row w-[135px] h-[38px] justify-evenly items-center">
      <Placeholder
        type="round"
        loading
        style={{ width: '16px', height: '16px', margin: '0px' }}
      />
      <Placeholder
        type="rect"
        loading
        style={{ width: '100px', height: '16px', margin: '0px' }}
      />
    </div>
    <Placeholder
      type="rect"
      loading
      style={{
        width: '185px',
        height: '38px',
        borderRadius: '9999px',
        margin: '0px',
      }}
    />
  </div>
);

const MaterialThumbnailGroupDesktopPlaceholder = () => (
  <div className="hidden flex-row flex-wrap w-full h-24 justify-between overflow-hidden lg:flex">
    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map(
      index => (
        <div className="w-12 h-12 p-0.5">
          <Placeholder
            key={index}
            type="rect"
            loading
            style={{
              minWidth: '44px',
              minHeight: '44px',
              margin: '0px',
              borderRadius: '4px',
            }}
          />
        </div>
      )
    )}
  </div>
);

const MaterialThumbnailGroupTabletPlaceholder = () => (
  <div className="hidden md:flex lg:hidden flex-row w-full h-14 overflow-visible">
    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(index => (
      <div className="w-14 h-14 p-0.5 m-2">
        <Placeholder
          key={index}
          type="rect"
          loading
          style={{
            minWidth: '52px',
            minHeight: '52px',
            margin: '0px',
            borderRadius: '6px',
          }}
        />
      </div>
    ))}
  </div>
);

const MaterialThumbnailGroupMobilePlaceholder = () => (
  <>
    <div className="flex md:hidden flex-row w-full h-14 overflow-visible">
      {[0, 1, 2, 3, 4, 5].map(index => (
        <div className="w-12 h-12 p-0.5 m-2">
          <Placeholder
            key={index}
            type="rect"
            loading
            style={{
              minWidth: '48px',
              minHeight: '48px',
              margin: '0px',
              borderRadius: '6px',
            }}
          />
        </div>
      ))}
    </div>
    <div className="flex md:hidden flex-row w-full h-14 overflow-visible">
      {[0, 1, 2, 3, 4, 5].map(index => (
        <div className="w-12 h-12 p-0.5 m-2">
          <Placeholder
            key={index}
            type="rect"
            loading
            style={{
              minWidth: '48px',
              minHeight: '48px',
              margin: '0px',
              borderRadius: '6px',
            }}
          />
        </div>
      ))}
    </div>
  </>
);

const PDPSelectUpholsteryPlaceholder = () => (
  <div className="relative [border-bottom:1px_solid_#e5e5e5] pb-8">
    <ColorFiltersPlaceholder />
    <MobileColorFiltersPlaceholder />
    <PDPUpholsteryFiltersPlaceholder />
    <PDPUpholsterySortByPlaceholder />
    <ActiveFabricAndSwatchButtonPlaceholder />
    <MaterialThumbnailGroupDesktopPlaceholder />
    <MaterialThumbnailGroupTabletPlaceholder />
    <MaterialThumbnailGroupMobilePlaceholder />
  </div>
);

export default PDPSelectUpholsteryPlaceholder;
